export const PASSWORD_REGEX = /\S+/; // any non-empty string without whitespace
export const USERNAME_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$/; // standard email regex pattern
export const CODENTIFY_REGEX = /^[A-Z0-9]{14}$/;
export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
